/**
 * Utilitaire de règles typographiques pour le Playbook Amazon Ads
 * - Remplace les ":" par "—" (tiret cadratin)
 * - Force la majuscule uniquement au début des titres
 */

export const formatTitle = (text: string): string => {
  return text
    .replace(/—/g, ":")
    .replace(/\s+/g, " ")
    .trim();
};

export const formatLabel = (text: string): string => {
  return text.replace(/—/g, ":");
};

export const capitalize = (text: string): string => {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
